import React, { useEffect, useState } from "react";
import BaseLayout from "./BaseLayout";
import "../App.css";
import axios from "axios";
import { API_BASE } from "../api";
import { useParams } from "react-router-dom";

const UserPage = () => {
    // Get the username from the URL
    const { username } = useParams();
    const [userInfo, setUserInfo] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchUserData = async () => {
            try {
                setLoading(true);
                const userResponse = await axios.get(`${API_BASE}/data/get-user-by-username/${username}`);
                setUserInfo({
                    name: userResponse.data.firstName + " " + userResponse.data.lastName,
                    profilePicture: userResponse.data.profile_picture,
                    points: userResponse.data.score,
                    favoriteNFLTeam: userResponse.data.favorite_nfl_team,
                    favoriteNBATeam: userResponse.data.favorite_nba_team,
                    id: userResponse.data.id,
                    rank: userResponse.data.rank
                });
            } catch (error) {
                console.error("Error fetching user data", error);
            } finally {
                setLoading(false);
            }
        };

        fetchUserData();
    }, [username]);

    if (!loading && !userInfo) return <div>User not found.</div>;

    const displayName = `${userInfo?.name || ""}`.trim();

    return (
        <BaseLayout>
            <div className="account-page">
                <div className="user-info-box">
                    <div className="profile-section" style={{ position: 'relative' }}>
                        <div className="profile-picture-container" style={{ textAlign: 'center' }}>
                            {loading ? (
                                <p style={{ padding: '2rem 0', fontSize: '18px' }}></p>
                            ) : (
                                <img
                                    src={userInfo.profilePicture || '/default.jpg'}
                                    alt="User Profile"
                                    style={{
                                        width: '300px',
                                        height: '300px',
                                        borderRadius: '50%',
                                        objectFit: 'cover',
                                        margin: 'auto',
                                        display: 'block'
                                    }}
                                />
                            )}
                        </div>
                        <div className="profile-tags" style={{ textAlign: 'center', marginTop: '10px' }}>
                            {!loading && userInfo && ([1,4,5,13,22].includes(userInfo.id)) && (
                                <span className="badge badge-info">Founder</span>
                            )}
                            {!loading && userInfo && userInfo.rank === 1 && (
                                <span className="badge badge-gold">Leaderboard: 1st</span>
                            )}
                            {!loading && userInfo && userInfo.rank === 2 && (
                                <span className="badge badge-silver">Leaderboard: 2nd</span>
                            )}
                            {!loading && userInfo && userInfo.rank === 3 && (
                                <span className="badge badge-bronze">Leaderboard: 3rd</span>
                            )}
                        </div>
                        <div className="profile-details" style={{ textAlign: 'center', marginTop: '1rem' }}>
                            <p className="info-name">{loading ? 'Loading Profile...' : displayName || "Unknown User"}</p>
                            <p className="info-label">Points: {loading ? '' : userInfo.points || 0}</p>
                            <h3 className="info-title">Favorite Teams:</h3>
                            <ul className="subinfo-title" style={{ listStyleType: 'none', paddingLeft: '0' }}>
                                {loading ? (
                                    <li></li>
                                ) : (
                                    <>
                                        {userInfo.favoriteNFLTeam ? (
                                            <li>{userInfo.favoriteNFLTeam} (NFL)</li>
                                        ) : (
                                            <li>(No NFL team chosen)</li>
                                        )}
                                        {userInfo.favoriteNBATeam ? (
                                            <li>{userInfo.favoriteNBATeam} (NBA)</li>
                                        ) : (
                                            <li>(No NBA team chosen)</li>
                                        )}
                                    </>
                                )}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </BaseLayout>
    );
};

export default UserPage;